import { createAction, props } from '@ngrx/store';
import {
  EquipmentOverviewResponseDto,
  GetAllCatalogGroupsFilterOptionsDto,
  WebPubSubResponse
} from '@festo-ax/smartenance-shared-ui';
import { MachineBriefData } from 'app/models/api/machines';

/**
 * IMPORTANT NOTE FOR NAMING
 * For global sap actions we DO NOT follow our application conception to name failed action with Fail
 * at the end, because that triggers appear of snack bar and in case of break of connection we have
 * to many warnings on the view
 */
export enum SapGlobalsActionTypes {
  GetSystemStates = '[SapGlobals] Get System States',
  GetSystemStatesSuccess = '[SapGlobals] Get System States Success',
  GetSystemStatesFailed = '[SapGlobals] Get System States Failed',

  GetUserStates = '[SapGlobals] Get User States',
  GetUserStatesSuccess = '[SapGlobals] Get User States Success',
  GetUserStatesFailed = '[SapGlobals] Get User States Failed',

  GetManufacturingWorkcenterList = '[SapGlobals] Get Manufacturing Workcenter List',
  GetManufacturingWorkcenterListSuccess = '[SapGlobals] Get Manufacturing Workcenter List Success',
  GetManufacturingWorkcenterListFailed = '[SapGlobals] Get Manufacturing Workcenter List Failed',

  GetMaintenanceWorkcenterList = '[SapGlobals] Get Maintenance Workcenter List',
  GetMaintenanceWorkcenterListSuccess = '[SapGlobals] Get Maintenance Workcenter List Success',
  GetMaintenanceWorkcenterListFailed = '[SapGlobals] Get Maintenance Workcenter List Failed',

  GetFunctionalLocations = '[SapGlobals] Get Functional Locations',
  GetFunctionalLocationsSuccess = '[SapGlobals] Get Functional Locations Success',
  GetFunctionalLocationsFailed = '[SapGlobals] Get Functional Locations Failed',

  GetNotificationTypes = '[SapGlobals] Get Notification Types',
  GetNotificationTypesSuccess = '[SapGlobals] Get Notification Types Success',
  GetNotificationTypesFailed = '[SapGlobals] Get Notification Types Failed',

  GetSapMachineNames = '[SapGlobals] Get Sap Machine Names',
  GetSapMachineNamesSuccess = '[SapGlobals] Get Sap Machine Names Success',
  GetSapMachineNamesFailed = '[SapGlobals] Get Sap Machine Names Failed',

  GetOrderTypes = '[SapGlobals] Get Order Types',
  GetOrderTypesSuccess = '[SapGlobals] Get Order Types Success',
  GetOrderTypesFailed = '[SapGlobals] Get Order Types Failed',

  GetPlannerGroups = '[SapGlobals] Get Planner Groups',
  GetPlannerGroupsSuccess = '[SapGlobals] Get Planner Groups Success',
  GetPlannerGroupsFailed = '[SapGlobals] Get Planner Groups Failed',

  GetFailureTypes = '[SapGlobals] Get Failure Types',
  GetFailureTypesSuccess = '[SapGlobals] Get Failure Types Success',
  GetFailureTypesFailed = '[SapGlobals] Get Failure Types Failed',

  GetCatalogGroups = '[SapGlobals] Get Catalog Groups',
  GetCatalogGroupsSuccess = '[SapGlobals] Get Catalog Groups Success',
  GetCatalogGroupsFailed = '[SapGlobals] Get Catalog Groups Failed',

  GetActivityTypes = '[SapGlobals] Get Activity Types',
  GetActivityTypesSuccess = '[SapGlobals] Get Activity Types Success',
  GetActivityTypesFailed = '[SapGlobals] Get Activity Types Failed',

  GetLanguageTypes = '[SapGlobals] Get Language Types',
  GetLanguageTypesSuccess = '[SapGlobals] Get Language Types Success',
  GetLanguageTypesFailed = '[SapGlobals] Get Language Types Failed',

  GetAsyncSapMachines = '[SapGlobals] Get Async Sap Machines',
  GetAsyncSapMachinesSuccess = '[SapGlobals] Get Async Sap Machines Success',
  GetAsyncSapMachinesFailed = '[SapGlobals] Get Async Sap Machines Failed',

  ShowFail = '[SapGlobals] Show Fail',
}

export const getSystemStates = createAction(SapGlobalsActionTypes.GetSystemStates);
export const getSystemStatesSuccess = createAction(
  SapGlobalsActionTypes.GetSystemStatesSuccess, props<{ response: WebPubSubResponse<'getAllSystemStatus'> }>()
);
export const getSystemStatesFail = createAction(SapGlobalsActionTypes.GetSystemStatesFailed, props<{ error: unknown }>());

export const getUserStates = createAction(SapGlobalsActionTypes.GetUserStates);
export const getUserStatesSuccess = createAction(
  SapGlobalsActionTypes.GetUserStatesSuccess, props<{ response: WebPubSubResponse<'getAllUserStatus'> }>()
);
export const getUserStatesFail = createAction(SapGlobalsActionTypes.GetUserStatesFailed, props<{ error: unknown }>());

export const getManufacturingWorkcenterList = createAction(SapGlobalsActionTypes.GetManufacturingWorkcenterList);
export const getManufacturingWorkcenterListSuccess = createAction(
  SapGlobalsActionTypes.GetManufacturingWorkcenterListSuccess, props<{ response: WebPubSubResponse<'getAllManufacturingWorkCenters'> }>()
);
export const getManufacturingWorkcenterListFail = createAction(SapGlobalsActionTypes.GetManufacturingWorkcenterListFailed, props<{ error: unknown }>());

export const getMaintenanceWorkcenterList = createAction(SapGlobalsActionTypes.GetMaintenanceWorkcenterList);
export const getMaintenanceWorkcenterListSuccess = createAction(
  SapGlobalsActionTypes.GetMaintenanceWorkcenterListSuccess, props<{ response: WebPubSubResponse<'getAllMaintenanceWorkCenters'> }>()
);
export const getMaintenanceWorkcenterListFail = createAction(SapGlobalsActionTypes.GetMaintenanceWorkcenterListFailed, props<{ error: unknown }>());

export const getFunctionalLocations = createAction(SapGlobalsActionTypes.GetFunctionalLocations);
export const getFunctionalLocationsSuccess = createAction(
  SapGlobalsActionTypes.GetFunctionalLocationsSuccess, props<{ response: WebPubSubResponse<'getAllFunctionalLocations'> }>()
);
export const getFunctionalLocationsFail = createAction(SapGlobalsActionTypes.GetFunctionalLocationsFailed, props<{ error: unknown }>());

export const getNotificationTypes = createAction(SapGlobalsActionTypes.GetNotificationTypes);
export const getNotificationTypesSuccess = createAction(
  SapGlobalsActionTypes.GetNotificationTypesSuccess, props<{ response: WebPubSubResponse<'getAllNotificationTypes'> }>()
);
export const getNotificationTypesFail = createAction(SapGlobalsActionTypes.GetNotificationTypesFailed, props<{ error: unknown }>());

export const getSapMachineNames = createAction(SapGlobalsActionTypes.GetSapMachineNames);
export const getSapMachineNamesSuccess = createAction(
  SapGlobalsActionTypes.GetSapMachineNamesSuccess, props<{ response: { machines: MachineBriefData[] } }>()
);
export const getSapMachineNamesFail = createAction(SapGlobalsActionTypes.GetSapMachineNamesFailed, props<{ error: unknown }>());

export const getAsyncSapMachines = createAction(SapGlobalsActionTypes.GetAsyncSapMachines, props<{ searchText: string }>());
export const getAsyncSapMachinesSuccess = createAction(
  SapGlobalsActionTypes.GetAsyncSapMachinesSuccess, props<{ machines: EquipmentOverviewResponseDto[] }>()
);
export const getAsyncSapMachinesFail = createAction(SapGlobalsActionTypes.GetAsyncSapMachinesFailed, props<{ error: unknown }>());

export const getOrderTypes = createAction(SapGlobalsActionTypes.GetOrderTypes);
export const getOrderTypesSuccess = createAction(
  SapGlobalsActionTypes.GetOrderTypesSuccess, props<{ response: WebPubSubResponse<'getAllOrderTypes'> }>()
);
export const getOrderTypesFail = createAction(SapGlobalsActionTypes.GetOrderTypesFailed, props<{ error: unknown }>());

export const getPlannerGroups = createAction(SapGlobalsActionTypes.GetPlannerGroups);
export const getPlannerGroupsSuccess = createAction(
  SapGlobalsActionTypes.GetPlannerGroupsSuccess, props<{ response: WebPubSubResponse<'getAllMaintenancePlannerGroups'> }>()
);
export const getPlannerGroupsFail = createAction(SapGlobalsActionTypes.GetPlannerGroupsFailed, props<{ error: unknown }>());
/**
 * @deprecated
 * @use getCatalogGroups
 */
export const getFailureTypes = createAction(SapGlobalsActionTypes.GetFailureTypes);
export const getFailureTypesSuccess = createAction(
  SapGlobalsActionTypes.GetFailureTypesSuccess, props<{ response: WebPubSubResponse<'getAllMaintenanceNotificationCodes'> }>()
);
export const getFailureTypesFail = createAction(SapGlobalsActionTypes.GetFailureTypesFailed, props<{ error: unknown }>());

export const getCatalogGroups = createAction(SapGlobalsActionTypes.GetCatalogGroups, props<{ filterOptions: GetAllCatalogGroupsFilterOptionsDto }>());
export const getCatalogGroupsSuccess = createAction(
  SapGlobalsActionTypes.GetCatalogGroupsSuccess, props<{ response: WebPubSubResponse<'getAllCatalogGroups'> }>()
);
export const getCatalogGroupsFail = createAction(SapGlobalsActionTypes.GetCatalogGroupsFailed, props<{ error: unknown }>());

export const getActivityTypes = createAction(SapGlobalsActionTypes.GetActivityTypes);
export const getActivityTypesSuccess = createAction(
  SapGlobalsActionTypes.GetActivityTypesSuccess, props<{ response: WebPubSubResponse<'getAllActivityTypes'> }>()
);
export const getActivityTypesFail = createAction(SapGlobalsActionTypes.GetActivityTypesFailed, props<{ error: unknown }>());

export const getLanguageTypes = createAction(SapGlobalsActionTypes.GetLanguageTypes);
export const getLanguageTypesSuccess = createAction(
  SapGlobalsActionTypes.GetLanguageTypesSuccess, props<{ response: WebPubSubResponse<'getSupportedSapLanguages'> }>()
);
export const getLanguageTypesFail = createAction(SapGlobalsActionTypes.GetLanguageTypesFailed, props<{ error: unknown }>());

export const showFail = createAction(SapGlobalsActionTypes.ShowFail, props<{ error: unknown }>());
